import React from 'react';

import { DesktopAfterUserChoose } from './DesktopAfterUserChoosePage';
import { DesktopAfterUserChoosePageContainerProps } from './types';

const DesktopAfterUserChooseContainer: React.FC<DesktopAfterUserChoosePageContainerProps> = ({ onGetResultHandler, friend }) => {

  return (
    <DesktopAfterUserChoose
      friend={friend}
      onGetResultHandler={onGetResultHandler}
    />
  );
};

export default DesktopAfterUserChooseContainer;
